import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/forkJoin';


export const COURS_OPEN_SHOW = 'COURS_OPEN_SHOW';
export const COURS_OPEN_SHOW_SUCCESS = 'COURS_OPEN_SHOW_SUCCESS';

export const COURS_OPEN_EDIT = 'COURS_OPEN_EDIT';
export const COURS_OPEN_EDIT_SUCCESS = 'COURS_OPEN_EDIT_SUCCESS';

export const COURS_CLEAR = 'COURS_CLEAR';
export const COURS_CLEAR_SEARCH = 'COURS_CLEAR_SEARCH';
export const COURS_SEARCH = 'COURS_SEARCH';
export const COURS_CREATE = 'COURS_CREATE';
export const COURS_UPDATE = 'COURS_UPDATE';
export const COURS_UPDATE_HORAIRES = 'COUR_UPDATE_HORAIRE';
export const COURS_DELETE = 'COURS_DELETE';

export const COURS_SEARCH_SUCCESS = 'COURS_SEARCH_SUCCESS';
export const COURS_CREATE_SUCCESS = 'COURS_CREATE_SUCCESS';
export const COURS_UPDATE_SUCCESS = 'COURS_UPDATE_SUCCESS';
export const COURS_DELETE_SUCCESS = 'COURS_DELETE_SUCCESS';

export const COURS_ERROR = 'COURS_ERROR';

export const CoursActions = {
    clear: ({id, errorCallback}) => {
        return {
            type: COURS_CLEAR,
            payload: {id, errorCallback},
        };
    },

    clearSearch: ({errorCallback}) => {
        return {
            type: COURS_CLEAR_SEARCH,
            payload: {errorCallback},
        };
    },

    openShow: ({http, cours, inscription, params, errorCallback}) => {
        return {
            type: COURS_OPEN_SHOW,
            payload: {http, cours, inscription, params, errorCallback}
        };
    },
    openEdit: ({http, cours, inscription, params, errorCallback}) => {
        return {
            type: COURS_OPEN_EDIT,
            payload: {http, cours, inscription, params, errorCallback},
        };
    },

    search: ({http, model, form, params, errorCallback}) => {
        return {
            type: COURS_SEARCH,
            payload: {http, model, form, params, errorCallback},
        };
    },

    create: ({http, model, form, params, successCallback, errorCallback}) => {
        return {
            type: COURS_CREATE,
            payload: {http, model, form, params, successCallback, errorCallback}
        };
    },

    update: ({http, model, form, params, successCallback, errorCallback}) => {
        return {
            type: COURS_UPDATE,
            payload: {http, model, form, params, successCallback, errorCallback},
        };
    },

    // TODO Voir pour les paramètres à passer, peut-être uniquement id, jour t hiraireDebut
    updateHoraires: ({ http, model, form, params, successCallback, errorCallback }) => {
        console.log('updateHoraires');
        return {
            type: COURS_UPDATE_HORAIRES,
            payload: { http, model, form, params, successCallback, errorCallback },
        };
    },
    

    delete: ({http, model, params, successCallback, errorCallback}) => {
        return {
            type: COURS_DELETE,
            payload: {http, model, params, successCallback, errorCallback}
        };
    },

};

export const CoursEpics = [

    // COURS DELETE
    ($action, store) => {
        return $action.ofType(COURS_DELETE).mergeMap(action => {
            const {http, model, params, successCallback, errorCallback} = action.payload;

            return model.getResource('default', 'delete')
            .call(http, params)
            .map(data => {
                if (data > 0) {
                    successCallback(data);
                    return {
                        type: COURS_DELETE_SUCCESS,
                        payload: {id: params[0]['id']}
                    };
                } else {
                    errorCallback(data);
                    return {
                        type: COURS_ERROR,
                        error: data
                    };
                }
            });
        });
    },

    // COURS UPDATE
    ($action, store) => {
        return $action.ofType(COURS_UPDATE).mergeMap(action => {
            const {http, model, form, params, successCallback, errorCallback} = action.payload;
            return model.getResource('default', 'update')
            .call(http, form, params)
            .map(data => {
                if (data > 0) {
                    successCallback(data);
                    return {
                        type: COURS_UPDATE_SUCCESS,
                        payload: {id: data}
                    };
                } else {
                    errorCallback(data);
                    return {
                        type: COURS_ERROR,
                        error: data
                    };
                }
            })
            .catch((error) => {
                errorCallback(error);
                return Observable.of({
                    type: COURS_ERROR,
                    error
                });
            });
        });
    },
    // COURS UPDATE HORAIRE
    ($action, store) => {
        return $action.ofType(COURS_UPDATE_HORAIRES).mergeMap(action => {
            console.log('COURS_UPDATE_HORAIRES action');
            const { http, model, form, params, successCallback, errorCallback } = action.payload;
            return model.getResource('default', 'post')
                .call(http, 'updateHoraire', form, params)
                .map(data => {
                    if (data > 0) {
                        successCallback(data);
                        return {
                            type: COURS_UPDATE_SUCCESS,
                            payload: { id: data }
                        };
                    } else {
                        errorCallback(data);
                        return {
                            type: COURS_ERROR,
                            error: data
                        };
                    }
                })
                .catch((error) => {
                    errorCallback(error);
                    return Observable.of({
                        type: COURS_ERROR,
                        error
                    });
                });
        });
    },

    // COURS CREATE
    ($action, store) => {
        return $action.ofType(COURS_CREATE).mergeMap(action => {
            const {http, model, form, params, successCallback, errorCallback} = action.payload;

            return model.getResource('default', 'save')
            .call(http, form, params)
            .map(data => {
                if (data > 0) {
                    successCallback(data);
                    return {
                        type: COURS_CREATE_SUCCESS,
                        payload: data
                    };
                } else {
                    errorCallback(data);
                    return {
                        type: COURS_ERROR,
                        error: data
                    };
                }
            })
            .catch((error) => {
                errorCallback(error);
                return Observable.of({
                    type: COURS_ERROR,
                    error
                });
            });
        });
    },

    // COURS SEARCH
    ($action, store) => {
        return $action.ofType(COURS_SEARCH).mergeMap(action => {
            const {http, model, form, params, errorCallback} = action.payload;
            let stream = null;
            if (form.controls['id'].value) {
                stream = model.getResource('default', 'get')
                .call(http, 'findById', params);
            } else {
                stream = model.getResource('default', 'find')
                .call(http, form, [params[1]]); // On ne passe que l'année scolaire, pas l'id
            }
            return stream
            .map(data => {
                if (form.controls['id'].value) { // Recherche par id : on met le cours résultat dans un tableau
                    return {
                        type: COURS_SEARCH_SUCCESS,
                        payload: (data) ? [data] : [],
                    };
                } else { // Recherche par critères
                    return {
                        type: COURS_SEARCH_SUCCESS,
                        payload: data,
                    };
                }
            })
            .catch((error) => {
                errorCallback(error);
                return Observable.of({
                    type: COURS_ERROR,
                    error
                });
            });

        });
    },

    // COURS OPEN EDIT
    ($action, store) => {
        return $action.ofType(COURS_OPEN_EDIT).mergeMap(action => {
            console.log('action', action);
            const {http, cours, inscription, params, errorCallback} = action.payload;

            return Observable.forkJoin(
                cours.getResource('default', 'get').call(http, 'findById', params),
                inscription.getResource('default', 'get').call(http, 'findByCoursId', [params[0], true]),
            )
            .map(data => {
                const [coursBDD, inscriptions] = data;
                (<any>coursBDD).inscriptions = inscriptions;
                return {
                    type: COURS_OPEN_EDIT_SUCCESS,
                    payload: coursBDD
                };
            }
            ).catch((error) => {
                errorCallback(error);
                return Observable.of({
                    type: COURS_ERROR,
                    error
                });
            });
        });
    },

    // COURS OPEN SHOW
    ($action, store) => {
        return $action.ofType(COURS_OPEN_SHOW).mergeMap(action => {
            const {http, cours, inscription, params, errorCallback} = action.payload;
            return Observable.forkJoin(
                cours.getResource('default', 'get').call(http, 'findById', params),
                inscription.getResource('default', 'get').call(http, 'findByCoursId', [params[0], true]),
            ).map(data => {
                const [coursBDD, inscriptions] = data;
                (<any>coursBDD).inscriptions = inscriptions;

                return {
                    type: COURS_OPEN_SHOW_SUCCESS,
                    payload: coursBDD,
                };
            })
            .catch((error) => {
                errorCallback(error);
                return Observable.of({
                    type: COURS_ERROR,
                    error
                });
            });
        });
    },

];

const initialState = {
    loading: false,
    list: null,
    show: null,
    edit: null,
    searchForm: null,
};

export const CoursReducer = (state = initialState, action: any) => {

    switch (action.type) {
        case COURS_CLEAR:
            return {...state,
                loading: false,
                edit: {...state.edit, [action.payload.id]: null},
                show: {...state.show, [action.payload.id]: null}
            };
        case COURS_CLEAR_SEARCH:
            return {...state,
                loading: false,
                searchForm: null,
                list: null,
        };
        case COURS_SEARCH:
            return {...state,
                loading: true,
                searchForm: action.payload.form,
            };
        case COURS_OPEN_SHOW:
        case COURS_OPEN_EDIT:
        case COURS_CREATE:
        case COURS_DELETE:
            return {...state, loading: true};

        case COURS_CREATE_SUCCESS:
            return {...state, loading: false};

        case COURS_SEARCH_SUCCESS:
            return {...state, loading: false, list: action.payload};

        case COURS_DELETE_SUCCESS:
            return {...state,
                loading: false,
                list: state.list ? state.list.filter(famille => famille.id !== action.payload.id) : null,
                show: {...state.show, [action.payload.id]: null},
                edit: {...state.edit, [action.payload.id]: null},
            };

        case COURS_UPDATE_SUCCESS:
            return {...state,
                loading: false,
                edit: {...state.edit, [action.payload.id]: null},
                show: {...state.show, [action.payload.id]: null}
            };

        case COURS_OPEN_EDIT_SUCCESS:
            return {...state, edit: {...state.edit, [action.payload.id]: action.payload}, loading: false };

        case COURS_OPEN_SHOW_SUCCESS:
            return {...state, show: {...state.show, [action.payload.id]: action.payload}, loading: false };

        case COURS_ERROR:
            return {...state, loading: false};

        default:
            return state;
    }

};



// WEBPACK FOOTER //
// /builds/eveasoft/lea/lea-front/src/app/cours/models/cours.store.ts